import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getLabVisitorHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.get,
      endPoint.dynamicList({ path: "lab_visitors", ...action.payload }),
    );
    yield put({
      type: types.GET_LAB_VISITOR_SUCCESS,
      payload: data.response,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.GET_LAB_VISITOR_ERROR,
      payload,
    });
  }
}

export function* getLabVisitorWatcherSaga() {
  yield takeLatest(types.GET_LAB_VISITOR_START, getLabVisitorHandlerSaga);
}

//delete

function* deleteLabVisitorHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.delete,
      endPoint.deleteDyanamicItem("lab_visitors", action.payload),
    );
    yield put({
      type: types.DELETE_LAB_VISITOR_SUCCESS,
      payload: data,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.DELETE_LAB_VISITOR_ERROR,
      payload,
    });
  }
}

export function* deleteLabVisitorWatcherSaga() {
  yield takeLatest(types.DELETE_LAB_VISITOR_START, deleteLabVisitorHandlerSaga);
}

//single item

function* getSingleLabVisitorHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.get,
      endPoint.dynamicList({ path: `lab_visitors/${action.payload}` }),
    );
    yield put({
      type: types.SINGLE_LAB_VISITOR_SUCCESS,
      payload: data.response,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.SINGLE_LAB_VISITOR_ERROR,
      payload,
    });
  }
}

export function* getSingleLabVisitorWatcherSaga() {
  yield takeLatest(types.SINGLE_LAB_VISITOR_START, getSingleLabVisitorHandlerSaga);
}

//update
function* updateLabVisitorHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { path, dataId, body } = action.payload;
    const { data } = yield call(
      apiClient.put,
      path,
      { _id: dataId, ...body }
    );
    yield put({
      type: types.UPDATE_LAB_VISITOR_SUCCESS,
      payload: data,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.UPDATE_LAB_VISITOR_ERROR,
      payload,
    });
  }
}

export function* updateLabVisitorWatcherSaga() {
  yield takeLatest(types.UPDATE_LAB_VISITOR_START, updateLabVisitorHandlerSaga);
}
